<template>
    <b-container fluid class="animated fadeIn">
        <h1>Cadastro de Petição</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                v-model="filtrarPor"
                                                :show-labels="false"
                                                :options="opcoesFiltro"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Autor:" label-for="nome" class="text-label">
                                            <b-form-input v-model="filtro.nome" type="text" id="nome" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="CNPJ:" label-for="cnpj" class="text-label">
                                            <b-form-input v-model="filtro.cnpj" type="text" id="cnpj" maxlength="100" v-mask="['XX.XXX.XXX/XXXX-##']" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                            label="Município:"
                                            label-for="municipio">
                                            <multiselect
                                                name="municipio"
                                                v-model="filtro.municipio"
                                                :show-labels="false"
                                                :options="dados.municipios"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :preserve-search="false"
                                                placeholder="Selecione"
                                                track-by="codMunicipio"
                                                label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                            label="Tipo de Crédito:"
                                            label-for="tipoCredito">
                                            <multiselect
                                                name="tipoCredito"
                                                v-model="filtro.tipoCreditos"
                                                :show-labels="false"
                                                :options="dados.tiposCredito"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Situação:" label-for="situacao" class="text-label">
                                            <b-form-checkbox-group
                                                id="checkboxSituacao"
                                                v-model="filtro.situacao"
                                                :options="dados.situacao"
                                                name="checkboxSituacao">
                                            </b-form-checkbox-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="filtrar">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>
                            <b-button variant="primary" @click.prevent="incluir" class="fonte-branca ml-1">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="alterar">
                                <i class="fa fa-pencil"></i> Alterar
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="exibir">
                                <i class="fa fa-eye"></i> Exibir
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-col xs="12">
                        <div>
                            <b-row class="d-flex justify-content-between">
                                <b-col>
                                    <label class="mt-3">Petições - Quantidade: <strong>{{ configTable.rows }}</strong></label>
                                </b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                            <TabelaPeticao
                                :resultado="resultado"
                                :fields="fields"
                                :configTable="configTable"
                                :selecteds="selecteds"
                                @sortingChanged="consultar"
                                @consultar="consultar" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from '../components/CompBotaoExibirOcultarColuna'
import CompPaginacao from '../components/CompPaginacao'
import TabelaPeticao from './TabelaPeticao'

export default {
    name: 'ManterPeticao',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        TabelaPeticao
    },
    data() {
        return {
            fields: [
                {
                    key: "selecionar",
                },
            ],
            showColunms: [],
            filtro: {
                nome: null,
                cnpj: null,
                municipio: null,
                tipoCreditos: [],
                situacao: [1]
            },
            dados: {
                municipios: [],
                tiposCredito: [],
                situacao: [
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 }
                ]
            },
            filtrarPor: [{
                    id: 5,
                    filtro: 'Situação'
                }],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Autor'
                },
                {
                    id: 2,
                    filtro: 'CNPJ'
                },
                {
                    id: 3,
                    filtro: 'Município'
                },
                {
                    id: 4,
                    filtro: 'Tipo de Crédito'
                },
                {
                    id: 5,
                    filtro: 'Situação'
                },
            ],
            configTable: {
                perPage: 100,
                sortField: 'nomeAutor',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            resultado: [],
            selecteds: [],
        }
    },
    methods: {
        /**
         * Incluir
         */
        incluir(evt) {
            evt.preventDefault()
            this.$store.commit('setPeticao', null)
            this.$router.push({ path: '/peticao/editar' })
        },

        /**
         * Alterar
         */
        alterar(evt) {
            evt.preventDefault()
            if(this.selecteds[0]) {
                this.$store.commit('setPeticao', this.selecteds[0])
                this.$router.push({ path: '/peticao/editar' })
            }
        },

        /**
         * Exibir
         */
        exibir(evt) {
            evt.preventDefault()
            if(this.selecteds[0]) {
                this.$store.commit('setPeticao', this.selecteds[0])
                this.$router.push({ path: '/peticao/exibir' })
            }
        },

        /**
         * Consultar
         */
        async consultar() {
            this.selecteds = []
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if(this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/peticao/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                if(this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows
                }
            }).finally(() => {
                this.loadingExit()
            })

        },

        /**
         * Obter filtro
         */     
        obterFiltro() {
            return {
                nome: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.nome : null,
                cnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cnpj : null,
                municipio: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.municipio : null,
                tipoCreditos: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.tipoCreditos : null,
                situacoes: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.situacao : null,

            }
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                nome: null,
                cnpj: null,
                municipio: null,
                situacao: null
            }
            this.filtrarPor = []
            this.filtrar();
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.configTable.checkedAll = false
            this.resultado = []
            this.selecteds = []
            this.consultar()
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listarPR`)
            .then(response => {
              this.dados.municipios = response.data
            })
        },

        /**
         * Listar tipos de crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTipoCredito`)
            .then(response => {
              this.dados.tiposCredito = response.data
            })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'peticao'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if(i == 2 || i == 3 || i == 5 || i == 6)
                return 'text-center justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultar()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const msgPeticao = this.$store.getters.getMsgPeticao;
        if(msgPeticao) {
            this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [msgPeticao] });
            this.$store.commit("setMsgPeticao", null)
        }

        this.obterConfiguracaoUsuario()
        this.listarMunicipios()
        this.listarTipoCredito()

        this.consultar()

    }
    
}
</script>

<style scoped>

</style>